const SearchSkeletonLoader = ({ rows = 5 }) => {
  return (
    <div className='space-y-2'>
      {[...Array(rows)].map((_, index) => (
        <div
          key={index}
          className='flex items-center space-x-3 bg-white p-2 rounded-md shadow-sm'
        >
          {/* Icon */}
          <div className='w-6 h-6 bg-gray-200 rounded-full animate-pulse'></div>
          {/* Text */}
          <div className='flex-1'>
            <div className='h-4 bg-gray-200 rounded animate-pulse w-full'></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SearchSkeletonLoader;
